import styled from 'styled-components'

export const StyledSVG = styled.svg`
  border: none;
  g {
    fill: var(--decorator-contrast);
  }
`
